import { render, staticRenderFns } from "./UnitsTemplate.vue?vue&type=template&id=86e6374e"
import script from "./UnitsTemplate.vue?vue&type=script&lang=js"
export * from "./UnitsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports